// extracted by mini-css-extract-plugin
module.exports = {"countdown":"Se-z","srOnly":"Te-z"};